import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import { useTenantConfig } from "../context/TenantConfigContext";

const Layout = () => {
  const { tenantConfig } = useTenantConfig();
  const tenantName = tenantConfig.tenantDisplayName || "Company";
  const footerText =
    tenantConfig.footerText || `© ${new Date().getFullYear()} ${tenantName}. All rights reserved.`;

  return (
    <div className="min-h-screen flex flex-col bg-page-background">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <footer className="bg-footer p-4 mt-auto">
        <p className="text-center text-footer-text">{footerText}</p>
      </footer>
    </div>
  );
};

export default Layout;
